"use strict";

import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import { contextPath } from './const';

import Login from "./scene/Login";
import App from './App';

import WebFont from 'webfontloader';

WebFont.load({
    google: {
        families: ['Source Sans Pro:300,400,600,700,300italic,400italic,600italic','sans-serif']
    },
});

ReactDOM.render(
    <Router basename={contextPath}>
        <Switch>
            <Route path="/login" exact component={Login} />
            <Route component={App} />
        </Switch>
    </Router>,
    document.getElementById('react')
);
